module.exports = __webpack_public_path__ + "static/media/flapping_build.10e4be62.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/img/flapping_build.png
// module id = 984
// module chunks = 0